RivalIQ.apps.MetricsExplorer.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    function restrictToAdmin() {
        if (!RivalIQ.state.account.isAdmin()) {
            return '/overview';
        }
    }

    curations.MetricsExplorer = Dashboard.models.Curation.mixin({

        mixins: {
            curationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy
        },

        beforeFilters: [
            restrictToAdmin
        ],

        title: 'Metrics Explorer',

        widgetDefinitions: function () {
            return [{
                instanceId: 'metrics_explorer',
                widgetId: RivalIQ.enums.widgetTypes.METRICS_EXPLORER,
                props: {}
            }];
        }
    });
});
